import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/login', name: 'Login', component: () => import('@/views/LoginView.vue'), meta: { public: true } },
    {
      path: '/',
      component: () => import('@/layouts/AppLayout.vue'),
      meta: { requiresAuth: true },
      children: [
        { path: '', redirect: '/dashboard' },
        { path: 'dashboard', name: 'Dashboard', component: () => import('@/views/DashboardView.vue') },
        { path: 'connectors', name: 'Connectors', component: () => import('@/views/ConnectorsView.vue') },
        { path: 'ai-workflow', name: 'AIWorkflow', component: () => import('@/views/AIWorkflowView.vue') },
        { path: 'users', name: 'Users', component: () => import('@/views/UsersView.vue') },
        { path: 'analytics', name: 'Analytics', component: () => import('@/views/AnalyticsView.vue') },
        { path: 'readiness', name: 'Readiness', component: () => import('@/views/ReadinessView.vue') },
        { path: 'api-keys', name: 'ApiKeys', component: () => import('@/views/ApiKeysView.vue') },
        { path: 'api-docs', name: 'ApiDocs', component: () => import('@/views/ApiDocsView.vue') },
      ],
    },
    { path: '/:pathMatch(.*)*', redirect: '/' },
  ],
})

router.beforeEach(async (to) => {
  const auth = useAuthStore()
  if (to.meta.public) return true
  if (!auth.isAuthenticated) {
    await auth.initSession()
    if (!auth.isAuthenticated) return { name: 'Login' }
  }
  return true
})
